import { useBusinessDocumentsContext } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/BusinessDocumentsContext';
import {
  ListViewBody,
  ListViewLabel,
  Single,
} from '@moneyforward/ap-frontend-components';
import {
  ApprovingInvoiceReportFormInputResponse,
  ApprovingInvoiceReportPaymentInfoResponse,
  reportFormInputType,
} from 'ap-openapi';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from '.././styles.module.scss';
import {
  BusinessDocumentsFieldView,
  CombineLabelFieldView,
  CombineLabelFieldViewWithLink,
  DefaultFieldView,
  FileFieldView,
  InvoiceFileFieldView,
  InvoiceRegistrationNumberFieldView,
} from './index';

const cx = classNames.bind(styles);

// Main switch function
const switchViewType = (
  type: string,
  item: ApprovingInvoiceReportFormInputResponse
) => {
  switch (type) {
    case reportFormInputType.ApReportFormInputFileField:
      return <FileFieldView item={item} />;
    case reportFormInputType.ApReportFormInputBusinessDocumentsField:
      return <BusinessDocumentsFieldView />;
    case reportFormInputType.ApReportFormInputInvoiceFileField:
      return <InvoiceFileFieldView item={item} />;
    case reportFormInputType.ApReportFormInputCheckBox:
      return <CombineLabelFieldView item={item} />;
    case reportFormInputType.ApReportFormInputReportNumberForExpenseField:
    case reportFormInputType.ApReportFormInputContractNumberField:
      return <CombineLabelFieldViewWithLink item={item} />;
    case reportFormInputType.ApReportFormInputInvoiceRegistrationNumberField:
      return <InvoiceRegistrationNumberFieldView item={item} />;
    default:
      return <DefaultFieldView item={item} />;
  }
};

type SmartListViewDetailsProps = {
  data: ApprovingInvoiceReportPaymentInfoResponse;
};

export const SmartListViewDetails: FC<SmartListViewDetailsProps> = memo(
  ({ data }) => {
    const { isVisible } = useBusinessDocumentsContext();

    return (
      <ListViewBody className={cx('applicationContentContainer')}>
        {data?.report_form_inputs?.map((item, index) => {
          if (!isVisible(item)) {
            return null;
          }

          return (
            <div
              key={item?.label ?? `empty-${index}`}
              className={cx('singleContainer')}
            >
              <Single>
                <ListViewLabel key='left'>{item?.label ?? ''}</ListViewLabel>
                <ListViewBody
                  className={cx('listViewBodyContainer')}
                  key='right'
                >
                  {switchViewType(item?.type ?? '', item)}
                </ListViewBody>
              </Single>
            </div>
          );
        })}
      </ListViewBody>
    );
  }
);
SmartListViewDetails.displayName = 'SmartListViewDetails';
